import styled from 'styled-components';
import FlexBox from '../../../../../core/components/FlexBox';

const HeaderContainer = styled(FlexBox)`
  border-bottom: 1px solid #dbdbdb;
  padding: 10px;
`;

export default HeaderContainer;
